<template lang='pug'>
    div
        ElectricalPDSensorSelectorLinks
        div.fullwidth(v-if="$route.params.lang == 'en'")

            section.title-container
                h1.product-title BS-PD
                h2.product-subtitle Bushing Tap PD Sensor for Electrical PD Measurement

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/BS-PD.webp')
                            img( src='@/assets/photos/BS-PD.png', width="70%", alt='Bushing Sensor BS-PD', title='Bushing Sensor BS-PD')
                    .column.factsandbluebox
                        .factbox
                            span.headline Key Features:
                            ul
                                li Integrated measuring impedance Z#[sub m]
                                li PD measurement according IEC60270
                                li Various types available for all capacitive graded bushing types
                                li Voltage and PD signals
                                li Overvoltage failure due to an open circuit caused by unplugged or cut measuring cables is not possible
                        .bluebox
                            Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet BS-PD.pdf")
                            Maillink(to='support@bss-hs.de', sub='BS-PD', text='Contact Us', size=30, strokeWidth=2)                            
                            Sitelink(to="/en/products/pdm-600", text='PD Monitoring System PDM-600')
                            Sitelink(to="/en/products/pdm-80", text='PD Monitoring System PDM-80')
                            Sitelink(to="/en/products/pdm-600-mobile", text='PDM-600-Mobile')
                        
            div.margin-bottom
                p The compact bushing sensor BS-PD is available in different versions for all typical bushing measurement taps of the various bushing manufacturers. It contains the C#[sub 2] capacitance for voltage measurement and the measuring impedance Z#[sub m] (quadrupole) for PD measurement. Due to the design of this bushing sensor no overvoltage at the output can arise by unplugging the cable.


        div.fullwidth(v-if="$route.params.lang == 'de'")

            section.title-container
                h1.product-title BS-PD
                h2.product-subtitle Elektrischer TE-Sensor für Durchführungsmessanschlüsse

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/BS-PD.webp')
                            img( src='@/assets/photos/BS-PD.png', width="70%", alt='Durchführungssensor BS-PD', title='Durchführungssensor BS-PD')
                    .column.factsandbluebox
                        .factbox
                            span.headline Highlights:
                            ul
                                li Integrierte Messimpedanz (AKV)
                                li TE-Messung gemäß IEC60270
                                li Für kapazitiv gesteuerte Durchführungen verschiedenen Types
                                li Spannungs- und TE-Signale
                                li Keine Überspannung durch Erdungsfehler möglich
                        .bluebox
                            Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet BS-PD.pdf")
                            Maillink(to='support@bss-hs.de', sub='BS-PD', text='Kontakt', size=30, strokeWidth=2)
                            Sitelink(to="/de/products/pdm-600", text='TE-Monitoringsystem PDM-600')
                            Sitelink(to="/de/products/pdm-80", text='TE-Monitoringsystem PDM-80')
                            Sitelink(to="/de/products/pdm-600-mobile", text='PDM-600-Mobile')
                        
            section.margin-bottom
                p Der kompakte Bushingsensor BS-PD ist in verschiedenen Versionen für alle gängigen Durchführungsmessanschlüsse der verschiedenen Durchführungshersteller verfügbar. Er beinhaltet die C#[sub 2]-Kapazität für die Spannungsmessung und die Messimpedanz Z#[sub m] (Ankoppelvierpol AKV) zur TE-Messung. Konstruktionsbedingt kann bei diesem Bushingsensor keine Überspannung am Ausgang durch Abstecken des Kabels entstehen.
</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | BS-PD",
            description:
                "Teilentladungs(TE)-Sensor für Durchführungsmessanschlüsse",
        },
        en: {
            title: "BSS | BS-PD",
            description:
                "Bushing Tap Partial Discharge (PD) Sensor for Measurement in IEC60270 Range and Above",
        },
    },
};
</script>

<style scoped lang='sass'>
</style>